import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';

import {closeAddCompanyForm, updateField, updateCompany, displayError} from '../../actions/companies'

class AddCompany extends Component {

  static defaultProps = {

  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
  }

  closeDialog() {
    const { dispatch } = this.props
    dispatch(closeAddCompanyForm())
  }

  updateCompany() {
    const { dispatch } = this.props

    let selectedCompanies = this.props.company.buildings

    if (!selectedCompanies || (selectedCompanies && selectedCompanies.length == 0)) {
      return dispatch(displayError("Please specify one building for this company!"))
    }

    dispatch(updateCompany(this.props.company))
  }

  updateField(event) {
    const { dispatch } = this.props
    dispatch(updateField(event.target.name, event.target.value))
  }

  updateDomains(event) {
    const { dispatch } = this.props
    dispatch(updateField(event.target.name, event.target.value.split(',')))
  }

  handleChange(event, index, values) {
    const { dispatch } = this.props

    dispatch(updateField('buildings', values.map(building => this.props.buildings.find(b => b._id === building))))
  }

  render() {

    if (this.props.company) {

      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.closeDialog.bind(this)}
        />,
        <FlatButton
          label={this.props.company._id == null ? "Add Company" : "Update Company"}
          primary={true}
          onClick={this.updateCompany.bind(this)}
        />,
      ];

      var companyBuildingsIds = []

      if (this.props.company.buildings) {
        companyBuildingsIds = this.props.company.buildings
        companyBuildingsIds = companyBuildingsIds.map(building => building._id)
      }

      return (<Dialog
        actions={actions}
        title="Add Company"
        modal={true}
        open={this.props.company != null}>

        <TextField
          name="name"
          hintText="Name"
          floatingLabelText="Name"
          value={this.props.company.name}
          onChange={this.updateField.bind(this)}
        />
        <br />
        <SelectField
          multiple={true}
          hintText="Select a building"
          value={companyBuildingsIds}
          onChange={this.handleChange.bind(this)}
        >
          {this.props.buildings.map((building, index) =>
            <MenuItem
              value={building._id}
              primaryText={building.name}
              checked={companyBuildingsIds && companyBuildingsIds.indexOf(building._id) > -1}
            />
          )}
        </SelectField>
      <br />
      <TextField
        name="domains"
        hintText="Enter domains separated by coma"
        floatingLabelText="Domains"
        multiLine={true}
        rows={4}
        rowsMax={4}
        value={this.props.company.domains ? this.props.company.domains.join() : ''}
        onChange={this.updateDomains.bind(this)}
      />
      <div style={{color: "red"}}>{this.props.error}</div>
      </Dialog>)
    } else {
      return (<div />)
    }

  }
}

const mapStateToProps = state => {
  return state.companiesReducer
}

export default withRouter(
  connect(mapStateToProps)(AddCompany)
);



// WEBPACK FOOTER //
// ./src/components/companies/AddCompany.js